export enum MutationQuery {
    CREATE_ORDER = `
    mutation CreateOrder($photographerId: Int!, $warehouseId: Int!, $companyId: Int!, $userId: Int!, $stylesColorsSizes: [ModelColorSizeInput], $endDate: String, $comments: String) {
        createOrder(
            photographerId: $photographerId
            warehouseId: $warehouseId
            companyId: $companyId
            userId: $userId
            stylesColorsSizes: $stylesColorsSizes
            endDate: $endDate
            comments: $comments
        ) {
            success
            message
        }
    }
    `,
    EDIT_PHOTOGRAPHER = `
    mutation UpdatePhotographer($currentUserId: Int!, $companyId: Int!, $photographerId: Int!, $statusId: Int, $shotCost: Float, $maxItems: Int, $discountThreshold: Float, $discountPercentage: Float, $startDate: String, $endDate: String, $automaticRenewal: Boolean!, $brandIdCategoryId: [BrandIdCategoryIdInput]) {
        updatePhotographer(
            currentUserId: $currentUserId
            companyId: $companyId
            photographerId: $photographerId
            automaticRenewal: $automaticRenewal
            brandIdCategoryId: $brandIdCategoryId
            statusId: $statusId
            shotCost: $shotCost
            maxItems: $maxItems
            discountThreshold: $discountThreshold
            discountPercentage: $discountPercentage
            startDate: $startDate
            endDate: $endDate
        ) {
            success
            message
        }
    }
    `,
    UPDATE_TEMPLATE = `
    mutation UpdateTemplate($companyId: Int!, $currentUserId: Int!, $updateTemplate: UpdateTemplateInput) {
        updateTemplate(
            companyId: $companyId
            currentUserId: $currentUserId
            updateTemplate:$updateTemplate
        ) {
            success
            message
        }
    }
    `,
    DELETE_TEMPLATE = `
    mutation DeleteTemplate($companyId: Int!, $parentTemplateId: Int!, $currentUserId: Int!) {
        deleteTemplate(companyId: $companyId, parentTemplateId: $parentTemplateId, currentUserId: $currentUserId) {
            success
            message
        }
    }
    `
}